<template> 
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Financial Proposal</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col cols="6" class="text-right">
          <base-button type="primary" icon size="sm" @click="close()">
          <span class="btn-inner--text">Back / Close</span>
        </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body class="mx-6">
          <customer-information-demo></customer-information-demo>
          <cash-flow-statement-demo @cash-flow-statement-data="getCashFlowStatementData"></cash-flow-statement-demo>
          <net-worth-statement-demo @net-worth-statement-data="getNetWorthStatementData"></net-worth-statement-demo>
          <!-- <net-worth-statement-v1></net-worth-statement-v1> -->
          <b-col class="text-center">
              <base-button type="primary" icon size="sm" @click.prevent="underDevelopment()">Generate PDF</base-button>
          </b-col>
          <br>
      </b-card>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import CustomerInformationDemo from "@/views/FinancialProposal/demo/CustomerInformationDemo";
  // import CashFlowStatement from "@/views/FinancialProposal/CashFlowStatement";
  import CashFlowStatementDemo from "@/views/FinancialProposal/demo/CashFlowStatement-demowithdummydata";
  // import NetWorthStatement from "@/views/FinancialProposal/NetWorthStatement";
  // import NetWorthStatementDemo from "@/views/FinancialProposal/demo/NetWorthStatementDemo";
  // import NetWorthStatementV1 from "@/views/FinancialProposal/demo/NetWorthStatementV1";
  

  export default {
    
    components: {
      CustomerInformationDemo,
      // CashFlowStatement,
      CashFlowStatementDemo,
      // NetWorthStatement,
      // NetWorthStatementDemo,
      // NetWorthStatementV1,
      RouteBreadCrumb,
    },
    data() {
      return {
        cashFlowStatement: [],
        netWorthStatement: [],
      };
    },
    methods: {
      close() {
        this.$router.back();
      },
      getCashFlowStatementData(value)
      {
        this.cashFlowStatement = value;
      },
      getNetWorthStatementData(value)
      {
        this.netWorthStatement = value;
      },
      generatePDF() {
      }
    }
  };
</script>
  